<template>
  <div class="flex flex-column">
    <div class="flex head">
      <div class="icon"></div>
    </div>
    <div class="form">
      <input type="text" class="input" v-model="phone" placeholder="请输入手机号"/>
      <div class="line"></div>
      <input type="password" class="input" v-model="password" placeholder="请输入密码"/>
      <div class="line"></div>
      <input type="password" class="input" v-model="passwordConfirm" placeholder="请确认密码"/>
      <div class="line"></div>
      <div class="flex flex-row align-center">
        <input type="text" class="input" v-model="code" placeholder="请输入验证码" />
        <div class="send_code_btn" @click="sendCode">{{sendCodeBtnName}}</div>
      </div>
      <div class="line"></div>
      <div class="readline">
        <div class="left_btn" @click="setRead">
          <div class="radio">
            <div class="radio_choose" v-if="isRead"></div>
          </div>
        </div>
        <div class="right_text">
          勾选表示您已阅读<span style="color:#FAAB32;" @click="toLocalPage">《用户隐私政策》</span>，并愿意成为千来聚易测用户
        </div>
      </div>
      <div class="flex justify-center" style="width: 100%">
        <div class="submit" @click="signIn">注册</div>
      </div>
      <div class="flex justify-center" style="width: 100%;">
        <div class="submit" style="margin-top:0.5rem;" @click="toDownload">已有账号，去下载</div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/css/flexbox.css';
import { Toast } from 'vant';

export default {
  props: ['agentCode', 'sharerPhone'],
  data() {
    return {
      phone: null,
      password: null,
      passwordConfirm: null,
      code: null,
      isRead: false,
      sendCodeBtnName: '获取验证码',
      canSend: true
    };
  },
  methods: {
    sendCode() {
      if (!this.canSend) {
        return;
      } 
      if (!this.phone) {
        Toast.fail('请先输入手机号');
        return;
      }
      if (!/^1\d{10}/.test(this.phone)) {
        Toast.fail('手机号格式不正确');
        return;
      }
      this.canSend = false;
      this.sendCodeBtnName = '正在发送';
      this.axios.post(`/api/login/getVerify`, {
        phone: this.phone
      }).then((data) => {
        if (data.code == 0) {
          // todo 临时测试增加验证码
          this.code = data.data;
          this.startInterval();
        }
      })
    },
    startInterval() {
      let time = 60
      const interval = setInterval(() => {
        this.sendCodeBtnName = `重新获取(${time}s)`
        time-=1;
        if (time == 1) {
          clearInterval(interval);
          this.sendCodeBtnName = '获取验证码';
          this.canSend = true;
        }
      }, 1000)
    },
    setRead() {
      if (this.isRead) {
        this.isRead = false;
      } else {
        this.isRead = true;
      }
    },
    signIn() {
      if (!this.phone) {
        Toast.fail('请输入手机号');
        return;
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        Toast.fail('手机号格式不正确');
        return;
      }
      if (!this.password) {
        Toast.fail('请输入密码');
        return;
      }
      if (this.password != this.passwordConfirm) {
        Toast.fail('两次输入的密码不一致');
        return;
      }
      if (!this.code) {
        Toast.fail('请输入验证码');
        return;
      }
      if (!this.isRead) {
        Toast.fail('请确认您已阅读《用户隐私政策》');
        return;
      }
      this.axios.post('/api/register', {
        phone: this.phone,
        code: this.code,
        password: this.password,
        agent_code: this.agentCode,
        sharer_phone: this.sharerPhone
      }).then((data) => {
        if (data.code == 0) {
          this.$router.push('/download');
        } else {
          Toast.fail(data.msg);
        }
      })
    },
    toLocalPage() {
      this.$router.push('/secretAgreement')
    },
    toDownload() {
      this.$router.push('/download');
    }
  }
};
</script>

<style lang="less" scoped>
.icon {
  background-image: url('../assets/imgs/logo-150.png');
  height: 2rem;
  width: 2rem;
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1.71rem;
  margin-bottom: 0.74rem;
}
.head {
  width: 100%;
  justify-content: center;
}
.form {
  width: 100%;
}
.input {
  width: 90%;
  color: #432F12;
  font-size: 0.43rem;
  line-height: 0.6rem;
  border: 0px;
  outline: 0px;
  background-color: #FFF;
  margin: 0.47rem 0.4rem 0.47rem 0.4rem;
}
.input::-webkit-input-placeholder{
  color:#CCC4B8;
}
.line {
  border-top: 0.01rem solid #E6E6E6;
  margin: 0 0.27rem 0 0.27rem;
}
.send_code_btn {
  width: 5rem;
  margin-right: 0.4rem;
  font-size: 0.43rem;
  font-weight: 800;
  line-height: 0.6rem;
  color: #FAAB32;
  text-align: right;
}
.readline {
  margin: 0.4rem 0.27rem 0 0.27rem;
  display: flex;
  flex-direction: row;
}
.radio {
  border: 0.03rem solid #FAAB32;
  height: 0.4rem;
  width: 0.4rem;
  border-radius: 50%;
}
.radio_choose {
  position: relative;
  height: 0.21rem;
  width: 0.21rem;
  background-color: #FAAB32;
  border-radius: 50%;
  top: 0.06rem;
  left: 0.06rem;
}
.left_btn {
  height: 1.01rem;
  display: flex;
  width: 0.66rem;
  justify-content: center;
}
.right_text {
  width: 8.32rem;
  font-size: 0.35rem;
  font-weight: 400;
  line-height: 0.52rem;
  color: #432F12;
}
.submit {
  margin-top: 0.8rem;
  width: 6.93rem;
  height: 1.31rem;
  border-radius: 1.17rem;
  background-color: #FAAB32;
  color: white;
  font-size: 0.43rem;
  font-weight: bold;
  line-height: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>